export default __webpack_public_path__ + "static/1-a616b71aa272d20114971caa7cfb3614.jpeg";